var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logout 1",
    clipPath: "url(#clip0_8092_42229)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.9493 7.07868C15.9153 6.99734 15.8667 6.92334 15.8047 6.86134L13.8053 4.86199C13.5447 4.60199 13.1233 4.60199 12.8627 4.86199C12.602 5.12265 12.602 5.54465 12.8627 5.80465L13.7247 6.66665H10.0006C9.63198 6.66665 9.33398 6.9653 9.33398 7.3333C9.33398 7.7013 9.63198 7.99996 10.0006 7.99996H13.7246L12.8626 8.86196C12.602 9.12262 12.602 9.54462 12.8626 9.80462C12.9926 9.93527 13.1633 9.99996 13.334 9.99996C13.5047 9.99996 13.6753 9.93531 13.8053 9.80462L15.8047 7.80527C15.8667 7.74393 15.9153 7.66993 15.9493 7.58793C16.0166 7.42534 16.0166 7.24134 15.9493 7.07868Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.3333 9.33334C10.9647 9.33334 10.6667 9.632 10.6667 10V13.3333H8V2.66666C8 2.37266 7.80666 2.11266 7.52466 2.028L5.20931 1.33334H10.6667V4.66669C10.6667 5.03469 10.9647 5.33334 11.3333 5.33334C11.702 5.33334 12 5.03469 12 4.66669V0.666687C12 0.298656 11.702 0 11.3333 0H0.666656C0.642656 0 0.621312 0.01 0.598 0.0126563C0.566656 0.016 0.538 0.0213125 0.508 0.0286562C0.438 0.0466563 0.374656 0.074 0.315344 0.111313C0.300687 0.120656 0.282688 0.121312 0.268688 0.131969C0.263313 0.136 0.261312 0.143344 0.255969 0.147344C0.183313 0.204656 0.122656 0.274656 0.0786562 0.358C0.0693125 0.376 0.0673125 0.395344 0.06 0.414C0.0386562 0.464656 0.0153437 0.514 0.00734375 0.57C0.004 0.59 0.01 0.608656 0.00934375 0.628C0.0086875 0.641344 0 0.653344 0 0.666656V14C0 14.318 0.224656 14.5913 0.536 14.6533L7.20266 15.9867C7.246 15.996 7.29 16 7.33331 16C7.48597 16 7.63597 15.9474 7.75597 15.8487C7.90997 15.722 7.99997 15.5333 7.99997 15.3333V14.6667H11.3333C11.702 14.6667 12 14.368 12 14V10C12 9.632 11.702 9.33334 11.3333 9.33334Z",
    fill: "black"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8092_42229"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/logoutIcon.e64fa6e30b9d6c60e730dfce72986d01.svg";
export { ForwardRef as ReactComponent };